import { Box, Button} from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../../assets/19.png';

function Header() {


  return (
    <Box 
      sx={{
        display: 'flex',
        alignItems: { xs: 'flex-start', md: 'center' },  // Flex-start para alinhar o título no topo em telas pequenas
        justifyContent: { xs: 'center', md: 'space-between' },  // Centraliza o conteúdo em telas pequenas
        flexDirection: { xs: 'column', md: 'row' }, // Coluna em telas pequenas, linha em médias e grandes
        marginBottom: 2,
        paddingRight: 8,
        backgroundColor: '#103874',
        color: 'white',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      {/* Logo e Título */}
      <Box 
        sx={{ 
          display: { xs: 'none', md: 'flex' },  // Oculta a logo em telas pequenas
          alignItems: 'center',
        }}
      >
        <Box 
          component="img"
          src={Logo} 
          alt="Logo"
          sx={{ 
            height: '100px', 
            width: 'auto' 
          }}
        />

      </Box>

      
  

      {/* Botões */}
      <Box 
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-end' },  // Centraliza os botões em telas pequenas, à direita em telas médias
          alignItems: 'center',
          gap: 2,  // Espaçamento entre os botões
          flexDirection: { xs: 'row', md: 'row' },  // Mantém os botões lado a lado em todas as telas
        }}
      >
        <Button 
          component={Link} 
          to="/" 
          color="inherit"
          sx={{
            '&:hover': {
              backgroundColor: '#0a33ff',
              color: '#f1f1f1',
            }
          }}
        >
          Home
        </Button>
        <Button 
          component={Link} 
          to="/about" 
          color="inherit"
          sx={{
            '&:hover': {
              backgroundColor: '#F2C12E',
              color: '#f1f1f1',
            }
          }}
        >
          Sobre
        </Button>
        <Button 
          component={Link} 
          to="/contact" 
          color="inherit"
          sx={{
            '&:hover': {
              backgroundColor: '#4AC200',
              color: '#f1f1f1',
            }
          }}
        >
        
          Contato
        </Button>
     
  <Button
          component={Link} 
          to="/Seguro_residencial/Cotacao_residencial" 
          color="inherit"
          sx={{
            '&:hover': {
              backgroundColor: '#0a33ff',
              color: '#f1f1f1',
            }
          }}
        >
         residencial
        </Button>

      </Box>

      
    </Box>
  );
}

export default Header;
